import React from "react";
import { view } from "@orderofchaos/mvvm";
import styles from "./FieldSet.module.css";
import { FieldSetViewModel } from "./FieldSetViewModel";

export interface FieldSetProps {
  title?: string;
  children?: React.ReactNode;
}

const FieldSet: React.FC<FieldSetProps> = view(
  FieldSetViewModel,
)<FieldSetProps>(({ children, title, viewModel: { setRootRef } }) => {
  return (
    <section className={styles.root} ref={setRootRef}>
      {title && <label className={styles.field__title}>{title}</label>}
      {children}
    </section>
  );
});

export default FieldSet;
